export const STORAGE_PREFIX = 'ma_register_';
